import { render } from "./RulesIndex.vue?vue&type=template&id=26b34e3a"
import script from "./RulesIndex.vue?vue&type=script&lang=js"
export * from "./RulesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/rules/RulesIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26b34e3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26b34e3a', __exports__)) {
    api.reload('26b34e3a', __exports__)
  }
  
  module.hot.accept("./RulesIndex.vue?vue&type=template&id=26b34e3a", () => {
    api.rerender('26b34e3a', render)
  })

}


export default __exports__